import { STORAGE_KEYS } from './constants';

/** 写入 localStorage（救援目标 + 轨迹） */
export function savePersistentRescueData(targets, tracks) {
  try {
    localStorage.setItem(STORAGE_KEYS.targets, JSON.stringify(targets));
    localStorage.setItem(STORAGE_KEYS.tracks, JSON.stringify(tracks));
    console.log('救援数据已保存到localStorage');
  } catch (error) {
    console.error('保存救援数据失败:', error);
  }
}

/**
 * 从 localStorage 读取（不 setState）
 * @returns {{ targets: any[], tracks: any[] }}
 */
export function loadPersistentRescueData() {
  try {
    const savedTargets = localStorage.getItem(STORAGE_KEYS.targets);
    const savedTracks = localStorage.getItem(STORAGE_KEYS.tracks);

    let loadedTargets = [];
    let loadedTracks = [];

    if (savedTargets) {
      loadedTargets = JSON.parse(savedTargets);
      console.log('从localStorage加载救援目标:', loadedTargets.length, '个');
    }

    if (savedTracks) {
      loadedTracks = JSON.parse(savedTracks);
      console.log('从localStorage加载救援轨迹:', loadedTracks.length, '个');
    }

    return { targets: loadedTargets, tracks: loadedTracks };
  } catch (error) {
    console.error('加载救援数据失败:', error);
    return { targets: [], tracks: [] };
  }
}

export function saveRescueTargetsToStorage(targets) {
  localStorage.setItem(STORAGE_KEYS.targets, JSON.stringify(targets));
}

export function saveRescueTracksToStorage(tracks) {
  localStorage.setItem(STORAGE_KEYS.tracks, JSON.stringify(tracks));
}
